import React from 'react';
import { SearchIcon } from 'lucide-react';
/**
 * Search trigger. Opens the platform search UI (no navigation).
 */
export function Search() {
  return <button type="button" className="text-gray-600 hover:text-blue-600 transition-colors" aria-label="Search" data-id="element-101">
      <SearchIcon className="w-5 h-5" data-id="element-102" />
    </button>;
}